import {useTranslation} from "react-i18next";

export const offerStatus = () => {
  const {t} = useTranslation();

  return [
    {id: "OPEN", name: t('offer.status.open'), className: "is-success"},
    {id: "SENT", name: t('offer.status.sent'), className: "is-warning"},
    {id: "REJECTED", name: t('offer.status.rejected'), className: "is-danger"},
    {id: "BOOKING_PENDING", name: t('offer.status.booking_pending'), className: "is-info"},
    {id: "BOOKED", name: t('offer.status.booked'), className: "is-info"}
  ];
}
